module.exports = __webpack_public_path__ + "img/social-icons.67e13341.png";